var _style, _defs, _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconoPuerto(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 33.17 33.04",
    style: {
      enableBackground: "new 0 0 33.17 33.04"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{clip-path:url(#SVGID_00000153690458318304217670000009855671613648251839_);}\n\t.stPortIcon{fill:#283046;}\n")), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    x: 0.25,
    y: 0.19,
    width: 32.66,
    height: 32.67
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000083792212306192350480000005767934051930325673_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1",
    style: {
      clipPath: "url(#SVGID_00000083792212306192350480000005767934051930325673_)"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4",
    className: "stPortIcon",
    d: "M17.13,30.14c0,0.3-0.24,0.54-0.54,0.54c-0.3,0-0.54-0.24-0.54-0.54 c0-0.3,0.24-0.54,0.54-0.54S17.13,29.84,17.13,30.14L17.13,30.14"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5",
    className: "stPortIcon",
    d: "M22.37,23.81c6.13-3.2,8.51-10.76,5.32-16.89S16.93-1.59,10.8,1.61S2.29,12.37,5.48,18.5 c1.19,2.27,3.04,4.13,5.32,5.32c-7,0.52-10.54,2.01-10.54,4.42c0,3.83,8.88,4.63,16.33,4.63s16.33-0.8,16.33-4.63 C32.91,25.82,29.37,24.33,22.37,23.81z M7.33,12.72c-0.01-5.12,4.14-9.27,9.25-9.28c5.12-0.01,9.27,4.14,9.28,9.25 s-4.14,9.27-9.25,9.28c-2.46,0-4.82-0.97-6.57-2.71C8.31,17.52,7.33,15.17,7.33,12.72z M16.58,31.77c-9.4,0-15.24-1.35-15.24-3.54 c0-1.78,3.9-3.02,10.71-3.41l1.06,1.06c-3.42,0.19-7.95,0.75-7.95,2.35c0,1.81,5.78,2.29,9.23,2.41h0.02 c0.3,0.01,0.55-0.23,0.56-0.53c0.01-0.3-0.23-0.55-0.53-0.56l0,0c-5.21-0.18-7.63-0.94-8.11-1.32c0.48-0.38,2.82-1.11,7.84-1.31 l1.37,1.37l0,0c0.29,0.26,0.67,0.4,1.06,0.4c0.41,0,0.8-0.15,1.11-0.42l1.34-1.34c5.02,0.2,7.36,0.93,7.84,1.31 c-0.49,0.39-2.9,1.14-8.11,1.32l0,0c-0.3,0.01-0.54,0.25-0.53,0.56s0.25,0.54,0.56,0.53h0.02c3.44-0.12,9.23-0.6,9.23-2.41 c0-1.6-4.53-2.16-7.95-2.35l1.06-1.06c6.8,0.39,10.71,1.63,10.71,3.41c0,2.18-5.84,3.54-15.24,3.54L16.58,31.77z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_6",
    className: "stPortIcon",
    d: "M17.25,20.47c0.68-0.31,6.68-3.11,6.68-7.22l0,0c0.05-0.9-0.63-1.67-1.53-1.73 c-0.9-0.05-1.67,0.63-1.73,1.53c0,0.07,0,0.13,0,0.2c0,0.79-0.9,1.85-2.46,2.92v-1.24c0.9-0.04,1.6-0.81,1.55-1.71 c-0.04-0.72-0.54-1.33-1.24-1.51c1.75-1.07,2.29-3.36,1.22-5.11c-1.07-1.75-3.36-2.29-5.11-1.22s-2.29,3.36-1.22,5.11 c0.31,0.5,0.72,0.91,1.22,1.22c-0.88,0.21-1.41,1.1-1.2,1.98c0.17,0.7,0.79,1.21,1.51,1.24v1.24c-1.55-1.07-2.46-2.13-2.46-2.92 c0.05-0.9-0.63-1.67-1.53-1.73c-0.9-0.05-1.67,0.63-1.73,1.53c0,0.07,0,0.13,0,0.2c0,4.1,6,6.91,6.68,7.22l0,0 C16.34,20.66,16.83,20.66,17.25,20.47L17.25,20.47z M15.09,8.54c0-0.83,0.67-1.5,1.5-1.5s1.5,0.67,1.5,1.5 c0,0.83-0.67,1.5-1.5,1.5c-0.4,0-0.78-0.16-1.06-0.44C15.24,9.32,15.09,8.94,15.09,8.54z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconoPuerto);
export default __webpack_public_path__ + "static/media/icono-puerto.95565438d469a218a8f54a2c93c76ca4.svg";
export { ForwardRef as ReactComponent };